/* NOTE: Resolving 'eslint-disable prefer-arrow-functions'
// will require architecture and refactoring of the entire WW engine
*/
import { CoreCustomPageType } from '@workflow/class/workflow.type';
import { CustomPageBase } from '@workflow/dynamic-render/page/shared/core-custom-page.decorator';

// eslint-disable-next-line @typescript-eslint/no-redundant-type-constituents
export type OLACustomPageType = CoreCustomPageType | 'ola-eligibility' | 'ola-interstitial';

// eslint-disable-next-line prefer-arrow-functions/prefer-arrow-functions
export function OLACustomPage(controlType: OLACustomPageType): (target) => void {
  return (target) => CustomPageBase<OLACustomPageType>(controlType, target);
}
